export default "__VITE_PUBLIC_ASSET__2be0c6a4__"